module.exports = __webpack_public_path__ + "img/ring_y_c_null_0.0752a786.png";